import React from "react";
import { node, string, number } from "prop-types";

import Typography from "@components/shared/Typography";

import { useGetFormattedPrice } from "@hooks/useGetFormattedPrice";

const DealSummaryItem = ({ title, image, name, type, description, price }) => {
  const getFormattedPrice = useGetFormattedPrice();

  return (
    <div className="border-t border-t-primaryOrange py-4">
      <Typography className="text-lg font-semibold uppercase">
        {title}
      </Typography>
      <div className="flex items-center my-4">
        <img
          className="rounded-sm max-w-20"
          src={image}
          alt={title}
          title={title}
        />
        <div className="flex flex-col flex-1-1-0 ml-4">
          <Typography
            className="font-semibold uppercase"
            data-id={`deal-summary-item-name-${type}`}
          >
            {name}
          </Typography>
          <div className="flex items-center gap-2">{description}</div>
        </div>
        <Typography
          className="font-semibold uppercase"
          data-id={`deal-summary-item-price-${type}`}
        >
          {price ? getFormattedPrice(price) : ""}
        </Typography>
      </div>
    </div>
  );
};

DealSummaryItem.propTypes = {
  title: node.isRequired,
  image: string.isRequired,
  name: string.isRequired,
  type: string.isRequired,
  description: node,
  price: number,
};

export default DealSummaryItem;
